import _util from '../../utils/';

const departmentDutyService = {
    fetchDepartmentDutyList(page, resolve, reject) {
        _util.request({
            url: '/api/HRBusiness/Get?Page='+page,
            success: resolve,
            error: reject
        })
    },
    fetchDutyCategoryList(resolve, reject) {
        _util.request({
            url: '/api/HRBusinessType/Get',
            success: resolve,
            error: reject
        })
    },
    addDutyCategory(posts, resolve, reject) {
        _util.request({
            url: '/api/HRBusinessType/Post',
            method: 'POST',
            data: posts,
            success: resolve,
            error: reject
        })
    },
    saveDutyCategory(puts, resolve, reject) {
        _util.request({
            url: '/api/HRBusinessType/Put',
            method: 'PUT',
            data: puts,
            success: resolve,
            error: reject
        })
    },
    deleteDutyCategory(deletes, resolve, reject) {
        _util.request({
            url: '/api/HRBusinessType/Delete?id='+deletes.id,
            method: 'DELETE',
            data: deletes,
            success: resolve,
            error: reject
        })        
    },
    fetchDutyLevelList(resolve, reject) {
        _util.request({
            url: '/api/HRBusinessLevel/Get',
            success: resolve,
            error: reject
        })
    },
    addDutyLevel(posts, resolve, reject) {
        _util.request({
            url: '/api/HRBusinessLevel/Create',
            method: "POST",
            data: posts,
            success: resolve,
            error: reject
        })
    },
    updateDutyLevel(puts, resolve, reject) {
        _util.request({
            url: '/api/HRBusinessLevel/Update',
            method: "PUT",
            data: puts,
            success: resolve,
            error: reject
        })
    },
    deleteDutyLevel(deletes, resolve, reject) {
        _util.request({
            url: '/api/HRBusinessLevel/Delete?id='+deletes.id,
            method: "DELETE",
            data: deletes,
            success: resolve,
            error: reject
        })
    },
    initDuty(resolve, reject) {
        _util.request({
            url: '/api/HRBusiness/Create',
            method: "get",
            success: resolve,
            error: reject
        })        
    },
    addDuty(posts, resolve, reject) {
        _util.request({
            url: '/api/HRBusiness/Post',
            method: "post",
            data: posts,
            success: resolve,
            error: reject
        }) 
    },
    multiDeleteDuty(deletes, resolve, reject) {
        _util.request({
            url: '/api/HRBusiness/Delete',
            method: "delete",
            data: deletes,
            success: resolve,
            error: reject
        }) 
    },
    updateDuty(puts, resolve, reject) {
        _util.request({
            url: '/api/HRBusiness/Put',
            method: "put",
            data: puts,
            success: resolve,
            error: reject
        }) 
    },
    saveAllDutyCategory (post, resolve, reject) {
        _util.request({
            url: '/api/HRBusinessType/Post',
            method: "post",
            data: post,
            success: resolve,
            error: reject
        })        
    },

    saveAllDutyLevel (post, resolve, reject) {
        _util.request({
            url: '/api/HRBusinessLevel/BatchCreate',
            method: "post",
            data: post,
            success: resolve,
            error: reject
        })        
    }
}

export default departmentDutyService;


// WEBPACK FOOTER //
// ./src/services/DepartmentStructure/department-duty-service.js